var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2085 13.2914C5.2085 11.8771 5.2085 11.1699 5.49439 10.5483C5.78029 9.92674 6.31721 9.46652 7.39105 8.54609L8.43272 7.65323C10.3737 5.98955 11.3442 5.15771 12.5002 5.15771C13.6562 5.15771 14.6267 5.98955 16.5676 7.65323L17.6093 8.54609C18.6831 9.46652 19.22 9.92674 19.5059 10.5483C19.7918 11.1699 19.7918 11.8771 19.7918 13.2914V17.7085C19.7918 19.6727 19.7918 20.6548 19.1816 21.265C18.5714 21.8752 17.5893 21.8752 15.6252 21.8752H9.37516C7.41098 21.8752 6.42888 21.8752 5.81869 21.265C5.2085 20.6548 5.2085 19.6727 5.2085 17.7085V13.2914Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1043 21.875V16.625C15.1043 16.0727 14.6566 15.625 14.1043 15.625H10.896C10.3437 15.625 9.896 16.0727 9.896 16.625V21.875",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.757d2c3cfcc684a8784616cf768153a6.svg";
export { ForwardRef as ReactComponent };